import { Link } from "react-router-dom";
import { OptimizedImage } from "@shared/components";
import type { CarouselProduct } from "@shared/types/carousel";

interface ProductCarouselSlideProps {
  product: CarouselProduct;
}

export function ProductCarouselSlide({ product }: ProductCarouselSlideProps) {
  const hasImage = product.images && product.images.length > 0;
  const imageUrl = hasImage ? product.images[0].url : undefined;

  return (
    <article className="flex h-full flex-col overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-md">
      <Link
        to={`/producto/${product.slug}`}
        className="relative block aspect-square overflow-hidden"
      >
        {imageUrl ? (
          <OptimizedImage
            src={imageUrl}
            alt={product.name}
            className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
            width={480}
            height={480}
            quality={80}
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gray-100 text-sm text-gray-500">
            Sin imagen
          </div>
        )}
      </Link>

      <div className="flex flex-1 flex-col gap-3 p-4">
        <div className="space-y-2">
          <Link
            to={`/producto/${product.slug}`}
            className="line-clamp-2 font-semibold text-gray-900 hover:text-[#282828]"
          >
            {product.name}
          </Link>
          <p className="text-xs uppercase tracking-wide text-gray-400">
            {product.slug}
          </p>
        </div>

        <div className="mt-auto">
          <Link
            to={`/producto/${product.slug}`}
            className="inline-flex w-full items-center justify-center rounded-lg bg-[#282828] px-4 py-2 text-sm font-medium text-white transition hover:bg-[#1a1a1a]"
          >
            Ver producto
          </Link>
        </div>
      </div>
    </article>
  );
}
